import type { AuthStatus } from '@/domain/types';
import type { StopTransactionDomain, StopTransactionResponse } from '@/protocol/OcppAdapter';

export function buildStopTransactionRequest(req: StopTransactionDomain): Record<string, unknown> {
  const wire: Record<string, unknown> = {
    transactionId: req.transactionId,
    meterStop: req.meterStop,
    timestamp: req.timestamp,
  };
  if (req.idTag !== undefined) wire['idTag'] = req.idTag;
  if (req.reason !== undefined) wire['reason'] = req.reason;
  // CR 2026-05-27 §3.3 — pass transactionData straight through. The
  // store builds it from `StopTxnSampledData` CSL config + the live
  // accumulator at stop time.
  if (req.transactionData !== undefined && req.transactionData.length > 0) {
    wire['transactionData'] = req.transactionData.map((mv) => ({
      timestamp: mv.timestamp,
      sampledValue: mv.sampledValue.map((sv) => {
        const out: Record<string, unknown> = { value: sv.value };
        if (sv.measurand !== undefined) out['measurand'] = sv.measurand;
        if (sv.unit !== undefined) out['unit'] = sv.unit;
        if (sv.context !== undefined) out['context'] = sv.context;
        if (sv.format !== undefined) out['format'] = sv.format;
        if (sv.location !== undefined) out['location'] = sv.location;
        if (sv.phase !== undefined) out['phase'] = sv.phase;
        return out;
      }),
    }));
  }
  return wire;
}

export function parseStopTransactionResponse(
  payload: Record<string, unknown>,
): StopTransactionResponse {
  const info = payload['idTagInfo'] as Record<string, unknown> | undefined;
  if (!info) return {};
  return {
    idTagInfo: {
      status: info['status'] as AuthStatus,
      ...(typeof info['expiryDate'] === 'string' ? { expiryDate: info['expiryDate'] } : {}),
      ...(typeof info['parentIdTag'] === 'string' ? { parentIdTag: info['parentIdTag'] } : {}),
    },
  };
}
